import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import PublicProfile from "@/pages/PublicProfile";
import Home from "@/pages/Home";

export default function ShopLink() {
  const { slug } = useParams();
  const [uid, setUid] = useState(null);
  useEffect(() => { api.get(`/shops/${encodeURIComponent(slug)}`).then((r) => setUid(r.data.user_id)).catch(() => setUid(false)); }, [slug]);
  if (uid === false) return <Home />;
  if (!uid) return <div className="max-w-4xl mx-auto p-4"><div className="skeleton h-48 rounded-[24px]" /></div>;
  return <PublicProfile userId={uid} shopFirst />;
}
